<!--
 * @LastEditors: Please set LastEditors
-->
<template>
  <div>
    <!-- 辅食tab -->
    <div class="tab" v-if="disparity?false:true">
      <div
        v-for="(item, index) in switchData"
        :key="index"
        @click="switchTab(index)"
        :class="item.isAct ? 'active' : ''"
      >
        <span>{{ item.ml == 0? '--' : item.ml }}{{ index == 3 ? 'g' : 'ml' }}</span>
        <span class="fs10">{{ item.title }}{{ item.count }}次</span>
      </div>
    </div>
    <!-- 辅食列表 -->
    <div class="feed-list" :style="!disparity?'':{background:'#F7F7F7'}">
      <div class="zhanwei"></div>
      <van-list
        class="ex_question_list"
        v-model="feedLoading"
        :offset="100"
        :finished="feedFinished"
        :finished-text="finishText"
        :error.sync="feedError"
        error-text="请求失败，点击重新加载"
        @load="getFeedList"
      >
        <div
          class="food-list"
          :style="!disparity?'':{marginTop:'0',marginBottom:'0'}"
          v-for="(item, idx) in searchResultList"
          :key="idx"
        >
          <div @click="goFeedDetail(item)" :style="!disparity?'':{marginTop:'0',borderRadius:'0',boxShadow:'initial'}">
            <img
              v-if="item.feedType == 1"
              src="@/assets/images/tools/feedRecord/type_3.png"
            />
            <img
              v-else-if="item.feedType == 2"
              src="@/assets/images/tools/feedRecord/type_1.png"
            />
            <img
              v-else-if="item.feedType == 3"
              src="@/assets/images/tools/feedRecord/type_4.png"
            />
            <img
              v-else-if="item.feedType == 4"
              src="@/assets/images/tools/feedRecord/type_2.png"
            />
            <div>
              <div>
                <span class="fs14">{{ item.feedTime  }}</span>
                <span>{{ item.feedType | feedState }}</span>
                <span
                  >{{ item.feedQuantity
                  }}{{ item.feedType == 4 ? 'g&nbsp;&nbsp;' : 'ml' }}</span
                >
                <div class="perch" v-if="item.feedType == 3"></div>
              </div>
              <div class="food-list-bt">
                <div>
                  <!-- <span>用量</span> -->
                  <span
                    class="fs10"
                    >第{{searchResultList.length-idx}}次</span
                  >
                </div>
                <ul v-if="item.feedType == 3">
                  <li>
                    <span>左侧哺乳{{ item.leftLactationTime }}分钟</span>
                  </li>
                  <li>
                    <span>右侧哺乳{{ item.rightLactationTime }}分钟</span>
                  </li>
                </ul>
                <ul v-if="item.feedType == 4">
                  <li v-for="item1 in item.supplementNames" :key="item1">
                    <span>{{ item1 }}</span>
                  </li>
                </ul>
              </div>
              <van-icon name="arrow" />
            </div>
          </div>
          <van-divider v-if="disparity"/>
        </div>
      </van-list>
      <div class="rez" v-if="searchResultList.length==0&&!disparity"></div>
      <!-- result zero(Home page) -->
      <div class="re0" v-if="!feedLoading&&disparity" :style="searchResultList.length==0&&disparity?'':{height:'37px'}">
        <div class="toast" v-if="searchResultList.length==0&&disparity"></div>
        <div class="add" v-if="!feedLoading&&disparity" @click="goAddRecord" :style="searchResultList.length==0&&disparity?{top:'72px',right:'50%',transform: 'translate(17px,-17px)'}:''"></div>
        <!-- <div class="text" v-if="searchResultList.length==0&&disparity" :style="searchResultList.length==0&&disparity?{}:''">科学喂养从添加记录开始～</div> -->
        <van-divider
          class="divider"
          v-if="searchResultList.length==0&&disparity"
          :style="{ color: '#1989fa', borderColor: '#eeeeee', padding: '0 22px' }"
        />
        <div class="stats" @click="goFoodIntake">查看宝宝食量统计</div>
      </div>
    </div>
    <slot name="swiper" v-if="!feedLoading"></slot>
  </div>
</template>

<script>
import FeedAPI from '@/utils/axiosApi/feedApi';
export default {
  name: 'feedList',
  props: ['feedType','feedDate','disparity'],

  watch: {
    feedDate(newValue, oldValue) {
      this.getFeedList();
    }
  },
  data() {
    return {
      switchData: [
        {
          title: '配方奶粉',//标题
          count: 0,//喂养量次数
          ml: 0,//喂养量
          type: 1,//类型
          isAct: false//是否选中
        },
        {
          title: '瓶装母乳',
          count: 0,
          ml: 0,
          type: 2,
          isAct: false
        },
        {
          title: '母乳亲喂',
          count: 0,
          ml: 0,
          type: 3,
          isAct: false
        },
        {
          title: '辅食',
          count: 0,
          ml: 0,
          type: 4,
          isAct: false
        }
      ],//tab数据

      searchResultList: [], //搜索列表
      searchResultParams: {
        size: 25,
        page: 1,
        type: [1, 2, 3, 4],
        feedDate: ''
      }, //分页
      tabType: [], //当前tab选中的类型
      feedLoading: false, //是否显示loading
      feedFinished: false, //是否加载完成
      finishText: '', //加载完成底部文字
      feedError: false // 是否显示错误提示
    };
  },
  filters: {
    feedState(value) {
      if (value === 1) {
        return '配方奶粉';
      } else if (value === 2) {
        return '瓶装母乳';
      } else if (value === 3) {
        return '母乳亲喂 ';
      } else if (value === 4) {
        return '辅食';
      }
    },
    // feedDate(date) {
    //   var mydate = new Date(date);
    //   var hours = mydate.getHours();
    //   var minutes = mydate.getMinutes();
    //   if (hours < 10) hours = '0' + hours;
    //   if (minutes < 10) minutes = '0' + minutes;

    //   return hours + ':' + minutes;
    // }
  },
  // created() {
  //   this.getFeedList();
  // },
  methods: {
    // 切换tab
    switchTab(index) {
      const val = this.switchData[index].isAct;
      if (!val) {
        this.tabType.push(this.switchData[index].type);
      } else {
        const arr = this.tabType;
        const position = arr.indexOf(this.switchData[index].type);
        arr.splice(position, 1);
        this.tabType = arr;
      }
      this.switchData[index].isAct = !this.switchData[index].isAct;
      this.searchResultParams.type = this.tabType;


      this.searchResultList = [];
      this.searchResultParams.page = 1;
      this.getFeedList();
    },
    // 请求列表数据
    getFeedList() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.feedLoading = true;


      FeedAPI.getfindFeedDiaryDesc(
        {},
        {
          data: {
            crmId: userInfo.crm_id,
            feedDate: this.feedDate,
            parity: this.$route.query.num || 1,
            feedTypeList:
              this.searchResultParams.type.length === 0
                ? [1, 2, 3, 4]
                : (this.searchResultParams.type).sort()
          },
          page: this.searchResultParams.page,
          size: this.searchResultParams.size
        },
        (res) => {
          if (res.code == 200) {
            this.feedFinished = false
            this.feedLoading = false;

            this.handleData(res.data); //处理
            var feedDiary = res.data.feedDiaryList;
            // 处理辅食格式
            for (let index = 0; index < feedDiary.length; index++) {
              if(feedDiary[index].supplementNames){
                  feedDiary[index].supplementNames = feedDiary[index].supplementNames.split(',');
              }
            }

            this.searchResultList = feedDiary;

            this.feedFinished = true;
            this.finishText = '';

            // if (
            //   this.searchResultParams.page >=
            //     Math.ceil(
            //       res.data.countNumber / this.searchResultParams.size
            //     ) ||
            //   Math.ceil(res.data.countNumber / this.searchResultParams.size) ===
            //     0
            // ) {
            //   this.feedFinished = true;
            //   this.finishText = '';
       
            // } else {
            //   this.searchResultParams.page += 1;
            // }
            if (
              this.searchResultParams.page == 1 &&
              res.data.feedDiaryList.length == 0
            ) {
              this.finishText = '当前条件下没有喂养记录哦~';
            }
          } else {
            this.feedLoading = false;
            this.feedError = true;
          }
        },
        (res) => {
          this.feedLoading = false;
          this.feedError = true;
        }
      );
    },

    // 点击跳转
    goFeedDetail(item) {
      this.$router.push({
        path: 'addFeed',
        query: { type: item.feedType, id: item.id, num: this.$route.query.num, monthAge: this.$route.query.monthAge, feedType: this.feedType}
      });
      sessionStorage.setItem('toolFeedDetail', JSON.stringify(item));
    },

    // 添加记录
    goAddRecord() {
      this.$emit('goAddRecord','')
    },

    // 食量统计
    goFoodIntake(){
      this.$emit('goFoodIntake','')
    },

    //处理数据
    handleData(data) {
      this.$emit('handleData', data);
      this.switchData[0].count = data.formulaMilkNumber;
      this.switchData[0].ml = data.formulaMilkQuantity;
      this.switchData[1].count = data.bottledMilkNumber;
      this.switchData[1].ml = data.bottledMilkQuantity;
      this.switchData[2].count = data.breastMilkNumber;
      this.switchData[2].ml = data.breastMilkQuantity;
      this.switchData[3].count = data.feedNumber;
      this.switchData[3].ml = data.feedQuantity;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-list__loading {
  background: #ffffff;
}
/deep/ .van-divider {
  margin: 0;
  padding: 0 10px;
  border-color: #EEEEEE;
  background: #fff;
}
/deep/ .van-list__finished-text {
  padding-top: 237px;
  padding-bottom: 430px;
}
.fs10 {
  transform: scale(0.85);
  display: inline-block;
}
.tab {
  margin: 0 12px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  div {
    width: 82px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    //  height: 39px;
    background: #ffffff;
    border-radius: 4px;
    padding: 8px 0;
    border: 1px solid #eeeeee;
    box-sizing: border-box;
    span {
      display: block;
    }
    span:first-child {
      color: #333333;
      font-weight: 600;
    }
    span:last-child {
      color: #666666;
    }
  }
  div.active {
    // border: 1px solid #FF7181;
    // border: 1px solid #FFF;
    border: none;
    background: url('../../../../../assets/images/tools/feedRecord/select_border.png') no-repeat top left/100% 100%;
    span:first-child {
      color: #FB6E7E;
    }
    span:last-child {
      color: #FF7181;
    }
  }
}

.feed-list {
  position: relative;
  background: #f2f2f2;
  .zhanwei {
    height: 1px;
    background: #fff;
  }
  .add {
    position: absolute;
    width: 34px;
    height: 34px;
    top: 52px;
    right: 12px;
    transform: translateY(-37px);
    background: url('../../../../../assets/images/tools/feedRecord/add_icon.png') no-repeat top left/34px 34px;
  }
  .rez {
    width: 184px;
    height: 131px;
    background: url('../../../../../assets/images/tools/feedRecord/rez.png') no-repeat top left/184px 131px;
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-92px);
  }
  .re0 {
    height: 143px;
    background: #fff;
    margin: 0 12px;
    border-radius: 0 0 8px 8px;
    .toast {
      width: 244px;
      height: 52px;
      margin: 0 auto;
      background: url('../../../../../assets/images/tools/feedRecord/re0.png') no-repeat top left/244px 52px;
    }
    // .text {
    //   color: #999;
    //   text-align: center;
    //   margin-top: 47px;
    // }
    .divider {
      position: absolute;
      bottom: 37px;
      left: 0;
      right: 0;
    }
    .stats {
      color: #fff;
      height: 20px;
      line-height: 22px;
      border-radius: 10px;
      background: #FB6E7E url('../../../../../assets/images/tools/feedRecord/triangle_icon.png') no-repeat right 10px center/4px 5px;
      // background-position-y: 6px;
      text-align: center;
      position: absolute;
      bottom: 9px;
      padding-left: 10px;
      padding-right: 17px;
      // padding-bottom: 1px;
      margin-left: 10px;
      box-sizing: border-box;
    }
  }
}

.food-list {
  margin: 10px 12px 0px;
  > div:first-child {
    background: #ffffff;
    margin-top: 10px;
    padding: 14px 12px;
    // box-shadow: 6px 0px 13px 0px rgba(244, 244, 244, 1),
    //   0px 6px 13px 0px rgba(244, 244, 244, 1);
    border-radius: 8px;

    img {
      width: 36px;
      height: 36px;
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
      // margin-top: 8px;
    }
    > div {
      width: 85%;
      display: inline-block;
      position: relative;
      > div:first-child {
        span:first-child {
          font-size: 14px;
          color: #111111;
          margin-right: 4px;
          font-weight: 500;
        }
        span:nth-child(2) {
          font-size: 14px;
          font-weight: 500;
          margin-right: 4px;
          color: #111111;
        }
        span:last-child {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
        }
        .perch {
          display: inline-block;
          width: 10px;
          height: 10px;
          background: url('../../../../../assets/images/tools/feedRecord/icon_about.png') no-repeat left top / 10px 10px;
          position: relative;
          top: -7px;
        }
      }
      .food-list-bt {
        margin-top: 3px;
        display: flex;
        > div {
          display: inline-block;
          // margin-top: 5px;
          width: 34px;
          span:first-child {
            font-size: 14px;
            // margin-right: 4px;
            font-weight: 400;
            color: #999999;
            white-space: nowrap;
          }
          // span:last-child {
          //   font-size: 11px;
          //   transform: scale(0.9);
          //   color: #333333;
          //   margin-right: 2px;
          // }
        }
        ul {
          width: 83%;
          display: inline-block;
          margin-left: 10px;
          li {
            float: left;
            // padding: 0px 4px;
            background: #FFF0F2;
            border-radius: 16px;
            color: #FF7181;
            margin-top: 4px;
            margin-right: 4px;
            height: 12px;
            line-height: 13px;
            padding: 0 5px;
            span {
              display: block;
              font-size: 10px;
              transform: scale(0.85);
            }
          }
        }
      }
      .van-icon-arrow {
        position: absolute;
        top: 50%;
        right: 2%;

        width: 5px;
        height: 8px;
        margin-top: -4px;
        color: #999999;
        font-size: 15px;
      }
    }
  }
}
</style>
